module.exports = __webpack_public_path__ + "static/media/DSCF0597-4.650d9699.jpg";